export const RoutingStateChangedKey = 'RoutingStateChanged';

export interface RoutingStateChanged {
  context?: any;
}



// WEBPACK FOOTER //
// ./src/Events/RoutingStateChanged.ts